import { render, staticRenderFns } from "./su1SurveyComponentEN.vue?vue&type=template&id=0db044cc"
import script from "./su1SurveyComponentEN.vue?vue&type=script&lang=js"
export * from "./su1SurveyComponentEN.vue?vue&type=script&lang=js"
import style0 from "./su1SurveyComponentEN.vue?vue&type=style&index=0&id=0db044cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports